import Vue from 'vue'
import { Button, Avatar, Icon, Dialog } from 'element-ui'

Vue.use(Button)
Vue.use(Avatar)
Vue.use(Icon)
Vue.use(Dialog)
